import { ApiProperty } from '@nestjs/swagger';
import { IsOptional } from 'class-validator';
import { Type } from 'class-transformer';

import { SpConnectOptionsValuesDto } from './sp-connect-options-values.dto';
import { SpConnectOptionsInterface } from '../interfaces/sp-connect-options.interface';

export class SpConnectOptionsDto implements SpConnectOptionsInterface {
  @ApiProperty()
  @IsOptional()
  name?: string;

  @ApiProperty()
  @IsOptional()
  type?: string;

  @ApiProperty()
  @IsOptional()
  note?: string;

  @ApiProperty()
  @Type(() => SpConnectOptionsValuesDto)
  values?: SpConnectOptionsValuesDto;
}
